import 'css-chunksrc/client/scenes/projectPortfolioEdition/form/colorPickerInput/styles.scss';export default {
  "colorPickerInput": "_colorPickerInput_xbqia_1",
  "colorInput": "_colorInput_xbqia_5",
  "color": "_color_xbqia_1"
};